import { Component, inject, Inject, Input, OnInit } from "@angular/core";
import { serviceStatus } from "../../../core/utils/tab.util";
import { Router } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Dialog } from "@angular/cdk/dialog";
import { SuccessComponent } from "../success/success.component";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-update-replacement-modal",
  template: ` <div class="w-full bg-gray-800 bg-opacity-50">
    <!-- Modal Card -->
    <div class="bg-white rounded shadow p-4 w-full">
      <h2 class="text-xl font-bold mb-4">Initiate Replacement</h2>
      <p class="mb-6">Are you sure you want to replacement?</p>

      <div class="flex justify-end space-x-2">
        <!-- Cancel Button -->
        <button
          type="button"
          class="bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded"
          (click)="onClose()"
        >
          No
        </button>

        <!-- Confirm Button -->
        <button
          type="button"
          class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
          (click)="onConfirm()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>`,
})
export class UpdateReplacementModalComponent {
  baseUrl = environment.url;
  token:any;
  private snackBar = inject(MatSnackBar);

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<UpdateReplacementModalComponent>,
    private http: HttpClient,
    private dialog:Dialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.token = localStorage.getItem("token");
  }
  onClose(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    const payload = {
      id: this.data.id,
      is_replacement: 1,
    };

    // Example API call
    this.http.patch(`${this.baseUrl}/update-replacement`, payload,  {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.token}`,
        'Content-Type': 'application/json'
      })
    }).subscribe({
      next: (res: any) => {
        console.log("Service confirmed:", res);
        // Navigate or close modal as desired
        if (res["success"]) {
          this.dialogRef.close();
          // this.router.navigate(["/services"]);
          this.dialog.open(SuccessComponent);
        }
      },
      error: (err) => {
        if(err.error.errors) {
          this.snackBar.open(err.error.errors,'',{duration:3000});
        } else {
          this.snackBar.open(err.error.error,'',{duration:3000});
        }
        console.error("Error confirming service:", err);
        // Show error message or handle accordingly
      },
    });
  }

 
}
